import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { productSlider } from "@omni/ui/brand/product/productSlider/productSlider.styles";
import { ProductTileLayout } from "@omni/ui/brand/product/productTile/productTile.config";
import { useMapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { ProductSlidersRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { useSlideContext } from "@/components/Product/ProductSlider/components/slider/components/slides/components/slide/context/slide.context";
import { useProductSliderContext } from "@/components/Product/ProductSlider/context/productSlider.context";
import ProductTileComponent from "@/components/Product/ProductTile/productTile.component";
import { useProductCartContext } from "@/utils/hooks/cart.hook";

type Props = {
    className?: string;
    children?: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { productTileConfig, analyticsContext, source } =
        useProductSliderContext();
    const { product } = useSlideContext();

    const { index } = useMapped();

    const cartContext = useProductCartContext();

    const tilePadding =
        productTileConfig.useInsidePadding ||
        source === ProductSliderSources.Recent;

    const { slider_slides_slide_productTile } = productSlider();

    return (
        <ProductTileComponent
            className={slider_slides_slide_productTile({ className })}
            product={product}
            cart={cartContext?.cart}
            allowInstantAddToCart={!!cartContext?.allowInstantAddToCart}
            productTileConfig={{
                amountOfFeatures: productTileConfig.amountOfFeatures,
                imageRenditions: ProductSlidersRenditions,
                border: false,
                tilePadding: tilePadding,
                components: ProductTileLayout.SLIDER(
                    productTileConfig.showButton,
                    productTileConfig.showCategoryLink,
                    productTileConfig.amountOfFeatures > 0
                )
            }}
            analyticsContext={
                analyticsContext && {
                    ...analyticsContext,
                    placement: index + 1
                }
            }
        >
            {children}
        </ProductTileComponent>
    );
};
